// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "app" + "." + "92a6fb82998ac0aa228d" + ".css";
};